import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getRouterBoardId } from '../../../../store/router/selectors/getRouterBoardId';
import { isHideTopBar } from '../../main/topBar/helpers/isHideTopBar';

export const cardPreviewSettingsCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.CARD_PREVIEW_SETTINGS);
    if (!hint) return false;
    if (
        !getRouterBoardId(state) // нет доски
    ) return false;
    const typeSwitcherList = document.querySelector('.type-switcher__list-group-settings');
    if (!typeSwitcherList) return false;

    return !isHideTopBar();
};
